module.exports = __webpack_public_path__ + "img/tpk.c8374fc1.jpg";